export default function readFileAsDataUrl(file: File | Blob) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    const onLoad = () => {
      if (typeof reader.result !== 'string') {
        return reject()
      }

      resolve(reader.result)
    }

    reader.addEventListener('load', onLoad, { once: true })
    reader.readAsDataURL(file)
  })
}
